module.exports = __webpack_public_path__ + "static/img/2-g.64d1747f.png";